var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowbtnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.36426C0.447715 6.36426 -6.43764e-08 6.81197 0 7.36426C6.43764e-08 7.91654 0.447715 8.36426 1 8.36426L1 7.36426L1 6.36426ZM16.7071 8.07136C17.0976 7.68084 17.0976 7.04767 16.7071 6.65715L10.3431 0.293189C9.95262 -0.0973354 9.31946 -0.0973354 8.92893 0.293189C8.53841 0.683714 8.53841 1.31688 8.92893 1.7074L14.5858 7.36426L8.92893 13.0211C8.53841 13.4116 8.53841 14.0448 8.92893 14.4353C9.31946 14.8258 9.95262 14.8258 10.3431 14.4353L16.7071 8.07136ZM1 7.36426L1 8.36426L16 8.36426L16 7.36426L16 6.36426L1 6.36426L1 7.36426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowbtnIcon);
export default __webpack_public_path__ + "static/media/arrowbtnIcon.aaf095738757912e952c9470b7996e84.svg";
export { ForwardRef as ReactComponent };